/**
 * Polyglot is a localization library written by Airbnb.
 * Project url: http://airbnb.io/polyglot.js/
 *
 * We'll be using it to bridge the gap between Laravel and Vue
 * All translations can be found within /resources/lang
 **/

import Polyglot from 'node-polyglot';
window.polyglot = new Polyglot({ phrases: Laravel.translations });

/**
* Speak plugin declaration
**/
const Speak = {
  install (Vue, options) {
    // Within the Vue community, it is generally expected that plugins which 
    // modify the Vue prototype prefix any added properties with a dollar sign ($).
    // this is referred to as an instance method

    // Adding $speak to Vue.prototype allows us to use $speak within Vue as this.$speak()
    Vue.prototype.$speak = function (key, args) {
      // Speak supports component options via the speak object
      // Currently it supports a 'prefix' key which will append itself to any translation key
      // eg. within your component you can use
      // speak: {
      //   prefix: 'app.components.OfferCard'
      // }

      if (this.$options.speak.prefix) {
        key = this.$options.speak.prefix + '.' + key;
      }

      return polyglot.t(key, args);
    }

    Vue.mixin({
      beforeCreate () {
        if (typeof this.$options.speak === 'undefined') {
          this.$options.speak = {
            prefix: ''
          }
        }
      }
    })
  }
};

export default Speak;


// WEBPACK FOOTER //
// ./resources/assets/js/shared/plugins/speak/index.js